<template>
  <div class="booxVersions-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span v-if="$route.query.id">编辑</span>
        <span v-else>新增</span>
      </div>
      <div class="right-part">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'booxClient' })"
        >
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="save('ruleForm')">
          {{ $t("commonMsg.save") }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          label-width="100px"
          @submit.native.prevent
          :model="formData"
          ref="ruleForm"
          label-position="top"
          :rules="rules"
        >
          <el-form-item label="标题" prop="name">
            <el-input v-model="formData.name"></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-radio-group v-model="formData.type">
              <el-radio
                v-for="item in typeData"
                :key="item.value"
                :label="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="服务" prop="type">
            <el-radio-group v-model="formData.folder">
              <el-radio
                v-for="item in folderData"
                :key="item.value"
                :label="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="版本号" prop="version">
            <el-input v-model="formData.version"></el-input>
          </el-form-item>

          <el-form-item label="描述" prop="desc">
            <el-input
              type="textarea"
              :rows="6"
              v-model="formData.desc"
              @keydown.enter.exact.prevent.native="handleLine"
            ></el-input>
          </el-form-item>
          <el-form-item label="Latest文件上传" prop="latest">
            <div>
              <p v-if="latestName">{{ latestName }}</p>
              <div v-if="isSave && latestFile">
                <el-progress
                  class="booxVersions-progress"
                  :percentage="latestFile.percentage"
                  color="#BF735B"
                ></el-progress>
                <span>（正在上传中,请不要退出当前界面）</span>
              </div>
            </div>
            <el-upload
              v-if="!isSave"
              action
              :auto-upload="false"
              :show-file-list="false"
              :on-change="handleLatestChange"
            >
              <el-button :disabled="isSave" size="small" type="primary"
                >点击上传</el-button
              >
            </el-upload>
          </el-form-item>
          <el-form-item label="安装压缩包上传" prop="isntallPackage">
            <div>
              <p v-if="packageName">{{ packageName }}</p>
              <div v-if="isSave && packageFile">
                <el-progress
                  class="booxVersions-progress"
                  :percentage="packageFile.percentage"
                  color="#BF735B"
                ></el-progress>
                <span>（正在上传中,请不要退出当前界面）</span>
              </div>
            </div>
            <el-upload
              v-if="!isSave"
              action
              :auto-upload="false"
              :show-file-list="false"
              :on-change="handlePackageChange"
            >
              <el-button :disabled="isSave" size="small" type="primary"
                >点击上传</el-button
              >
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OSS from "ali-oss";
export default {
  computed: {
    ...mapGetters(["buckets"]),
  },
  data() {
    return {
      formData: {
        name: "",
        version: "",
        type: "win32",
        folder: "beta",
        desc: "",
      },
      typeData: [
        {
          label: "window",
          value: "win32",
        },
        {
          label: "mac",
          value: "darwin",
        },
        {
          label: "linux",
          value: "linux",
        },
      ],
      folderData: [
        {
          label: "测试服",
          value: "beta",
        },
        {
          label: "正式服",
          value: "updater",
        },
      ],
      latestName: "",
      latestFile: null,
      packageName: "",
      packageFile: null,
      isSave: false,
      ossClient: null,
      bucket: "",
      params: {},
      rules: {
        name: [{ required: true, message: "不能为空", trigger: "change" }],
        version: [{ required: true, message: "不能为空", trigger: "change" }],
        url: [{ required: true, message: "不能为空", trigger: "change" }],
      },
    };
  },
  methods: {
    handleLine() {
      this.formData.description += "\n";
    },
    async getPcVersionDetails() {
      let res = await this.$http.getPcVersionDetails(this.$route.query.id);
      this.formData = Object.assign(this.formData, res.data);
      this.latestName = res.data.latest.name;
      this.packageName = res.data.package.name;
    },

    handleLatestChange(file) {
      this.latestFile = file;
      this.latestName = file.name;
    },

    handlePackageChange(file) {
      this.packageFile = file;
      this.packageName = file.name;
    },

    save(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.params = Object.assign({}, this.formData);
          this.ossClient = await this.getOssClient();
          if (this.$route.query.id) {
            this.edit();
          } else {
            this.create();
          }
        } else {
          return false;
        }
      });
    },

    async create() {
      if (!this.latestFile || !this.packageFile) {
        this.elMsg(this.$t("请上传相关文件"), "warning");
        return;
      }
      this.isSave = true;
      let key = `boox-pc/${this.params.folder}/${this.params.type}/x64`;
      this.params.latest = await this.uploadToOss(this.latestFile, key);
      this.ossClient.copy(
        this.filterOssKeyName(this.params.latest.key),
        this.params.latest.key
      );
      this.params.package = await this.uploadToOss(this.packageFile, key);
      await this.$http.createPcVersion(this.params);
      this.elMsg(this.$t("alertMsg.addSuccess"), "success");
      this.$router.back();
    },

    async edit() {
      let key = `boox-pc/${this.params.folder}/${this.params.type}/x64`;
      if (this.latestFile) {
        this.isSave = true;
        this.params.latest = await this.uploadToOss(this.latestFile, key);
        this.ossClient.copy(
          this.filterOssKeyName(this.params.latest.key),
          this.params.latest.key
        );
      }
      if (this.packageFile) {
        this.isSave = true;
        this.params.package = await this.uploadToOss(this.packageFile, key);
      }
      await this.$http.updatePcVersion(this.$route.query.id, this.params);
      await this.setOssLatestFile();
      this.elMsg("编辑成功", "success");
      this.$router.back();
    },

    async setOssLatestFile() {
      try {
        let prefix = `boox-pc/${this.params.folder}/${this.params.type}/x64`;
        let res = await this.ossClient.list({
          prefix,
        });

        let data = res.objects.find(
          (item) => ~item.name.indexOf(`latest-${this.params.version}`)
        );

        let newName = "";
        if (this.params.type === "win32") {
          newName = `${prefix}/latest.yml`;
        } else if (this.params.type === "darwin") {
          newName = `${prefix}/latest-mac.yml`;
        }
        this.ossClient.copy(newName, data.name);
        let ret = await this.ossClient.list({
          prefix,
        });
        console.log(ret.objects);
        return "ok";
      } catch (error) {}
    },

    filterOssKeyName(key) {
      if (this.params.type === "win32") {
        return key.replace(/latest/, `latest-${this.params.version}`);
      } else if (this.params.type === "darwin") {
        return key.replace(/latest-mac/, `latest-${this.params.version}`);
      }
    },

    async uploadToOss(file, key) {
      try {
        let data = await this.ossClient.multipartUpload(
          `${key}/${file.name}`,
          file.raw,
          {
            progress: (p, cpt, res) => {
              file.percentage = Number((p * 100).toFixed(1));
            },
          }
        );
        return {
          key: data.name,
          bucket: this.bucket,
          name: file.name,
          url: data.res.requestUrls[0].split("?")[0],
        };
      } catch (error) {
        throw new Error(error);
      }
    },

    async getOssClient() {
      try {
        let params = {};
        if (
          [
            "http://admin.onyx-international.cn",
            "https://admin.onyx-international.cn",
          ].includes(window.location.origin)
        ) {
          params = {
            cname: true,
            endpoint: "https://static.send2boox.com",
          };
        }
        let sts = await this.$http.aliyunSts();
        this.bucket = this.buckets["onyx-static"].bucket;
        let region = this.buckets["onyx-static"].region;
        let client = await new OSS({
          region,
          accessKeyId: sts.data.AccessKeyId,
          accessKeySecret: sts.data.AccessKeySecret,
          stsToken: sts.data.SecurityToken,
          bucket: this.bucket,
          secure: true,
          ...params,
        });

        return client;
      } catch (error) {
        throw new Error(error);
      }
    },
  },
  async mounted() {
    if (this.$route.query.id) {
      this.getPcVersionDetails();
    }
  },
};
</script>

<style lang="scss">
.booxVersions-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
    }
    .pic {
      .pic-item {
        /* position: relative; */
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }
      .global-button-style {
        width: 80px;
        height: 30px;
      }
      .booxVersions-edit-cover {
        position: relative;
        width: 200px;
        height: 300px;
        overflow: hidden;
        margin: 10px 0;
        border: 2px dashed #ccc;
        border-radius: 10px;
        &:hover {
          border-color: #bb745c;
        }
        > img {
          width: 100%;
          height: 100%;
        }
        > .booxVersions-edit-cover-icon {
          font-weight: bold;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #bb745c;
        }
        > .booxVersions-edit-upload {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          transition: all 0.2s;
          &:hover {
            transition: all 0.2s;
            background: rgba($color: #000000, $alpha: 0.4);
            .booxVersions-edit-upload-btn {
              display: block;
            }
          }
          .booxVersions-edit-upload-btn {
            width: 100%;
            height: 100%;
            display: none;
            cursor: pointer;
            color: #fff;
            font-weight: bold;
            position: absolute;
            text-align: center;
            line-height: 300px;
            > .el-upload--text {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .add-img {
        width: 70px;
        height: 40px;
        font-size: 22px;
        line-height: 43px;
        color: #fff;
        cursor: pointer;
        background-color: #bb745c;
      }
    }
  }
}
</style>
